/**
 * Function to parse and download CSV file to print from Add Cards Api. This function
 * is called after the cards have been created and the printer file is ready to download.
 * 
 * @param {object} data incoming data from AWS
 * @param {HTMLElement} partner html element
 * @param {HTMLElement} customer html element
 * @param {HTMLElement} cardgroup html element
 * 
 * @returns void
 */
export const downloadCSV = (data: any, partner: HTMLElement, customer: HTMLElement, cardgroup: HTMLElement) => {
  const d = new Date();
  const month = (d.getMonth() + 1);
  const day = (d.getDate());
  const year = d.getFullYear();

  const fileName = `${partner.innerText}_${customer.innerText}_${cardgroup.innerText}_${year}${month}${day}`;
  const formattedFileName = fileName.replace(/[^\w]/g, '');

  const replacer = (key: any, value: any) => value === null ? '' : value;
  const header = Object.keys(data[0]);

  const csv = [
    header.join(','), 
    ...data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
  ].join('\r\n');

  const hiddenElement = document.createElement('a');  
  hiddenElement.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
  hiddenElement.target = '_blank';      
  hiddenElement.setAttribute('download', formattedFileName + '.csv');  
  hiddenElement.click(); 
}